import { TypedStartListening, ListenerEffectAPI } from "@reduxjs/toolkit";
import { toast } from "sonner";
import { fetchFiles } from "./slices/fileSlice";
import { updateJobStatus, UploadStatuses } from "./slices/uploadFileSlice";
import { RootState, AppDispatch } from "./store";
import { selectAppToken } from "./slices/appAuthSlice";
import { listenerMiddleware } from "../middleware/listenerMiddleware";

export type AppStartListening = TypedStartListening<RootState, AppDispatch>;
export type AppListenerEffectAPI = ListenerEffectAPI<RootState, AppDispatch>;
export const startAppListening =
  listenerMiddleware.startListening as AppStartListening;

startAppListening({
  matcher: updateJobStatus.match,
  effect: async (action, listenerApi) => {
    const { uploadId, status } = action.payload;
    const state = listenerApi.getState();
    const dispatch = listenerApi.dispatch;
    const fileName =
      state.uploadFileReducer.jobs[uploadId]?.fileName || "Unknown file";

    if (status === UploadStatuses.COMPLETED) {
      const token = selectAppToken(state);
      if (!token) return;
      await dispatch(fetchFiles());
      toast.success(`File ${fileName} uploaded successfully.`);
    } else if (status?.startsWith("FAILED")) {
      const details = state.uploadFileReducer.jobs[uploadId]?.statusDetails;
      toast.error(`Upload failed: ${fileName}`, {
        description:
          details || "An error occurred during upload or processing.",
      });
    }
  },
});
